module.exports = __webpack_public_path__ + "assets/img/1501587607691_.pic_hd.ab7e81a6.jpg";